import { render, staticRenderFns } from "./supplyDetail.vue?vue&type=template&id=3780a1ed&scoped=true&"
import script from "./supplyDetail.vue?vue&type=script&lang=js&"
export * from "./supplyDetail.vue?vue&type=script&lang=js&"
import style0 from "./supplyDetail.vue?vue&type=style&index=0&id=3780a1ed&prod&lang=css&"
import style1 from "./supplyDetail.vue?vue&type=style&index=1&id=3780a1ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3780a1ed",
  null
  
)

export default component.exports